<template>
  <div v-if="$store.state.modals[id].visible" class="modal">
    <div class="modal-mask" @click="$emit('modal-close')" />
    <div class="modal-content-wrapper">
      <div
        :id="id"
        class="modal-contents"
        role="dialog"
        aria-modal="true"
      >
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
    props: ['id'],
    emits: ['modal-close'],
}
</script>

<style lang="scss" scoped>
// Dimmed, with faint scanlines.
.modal-mask {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: $color-overlay-strong;
    background-image: repeating-linear-gradient(0deg, rgba(255, 255, 255, 0.025) 0 2px, transparent 2px 4px);
    z-index: 100;
}
.modal-content-wrapper {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 200;
    display: flex;
    pointer-events: none;
    padding: 1rem;
}
.modal-contents {
    @include mc-tooltip(0.97);
    margin: auto;
    z-index: 1000;
    padding: 1.25rem 1.5rem;
    pointer-events: auto;
    animation: ssm-boot 0.3s steps(4, end);
}

#challengeModal {
    width: 100%;
    max-width: 1110px;
    min-height: 70%;
    max-height: 100%;
    height: 100%;
}
</style>
